import { ReduceStore } from 'flux/utils';
import Dispatcher from './Dispatcher';
import Constants from './Constants';

class PersonalInfoStore extends ReduceStore {
  constructor() {
    super(Dispatcher);
  }

  getInitialState() {
    return {};
  }

  reduce(state, action) {
    switch (action.actionType) {
      case Constants.APP_SET_PERSONAL_INFO:
        return action.infos;

      default:
        return state;
    }
  }
}

export default new PersonalInfoStore();



// WEBPACK FOOTER //
// ./src/flux/PersonalInfoStore.js